export default __webpack_public_path__ + "static/media/photo_of_me_black_white.0c5e35d5.jpg";